import type { FAQItem } from './accordion-data.types';

export const FAQ_CAR_DATA: FAQItem[] = [
    {
        question: 'O que é a Tabela FIPE?',
        answer: 'A Tabela FIPE, criada pela Fundação Instituto de Pesquisas Econômicas (FIPE), é reconhecida por divulgar preços médios de mercado de carros, motos e caminhões, novos, seminovos e usados, em todo o Brasil, para servir de parâmetro em negociações e avaliações dos automóveis. No entanto, para transações, além das estimativas da tabela, leva-se em consideração outros fatores como conservação, opcionais, revisões concluídas, entre outras especificidades que podem influenciar uma oferta.',
        questionJSX: <h3 data-testid="faq-question-01" id="faq-question-01">O que é a Tabela FIPE?</h3>,
        answerJSX: (
            <div data-testid="faq-content-01" id="faq-content-01">
                <p data-testid="faq-content-01-p1" id="faq-content-01-p1">
                    A <b>Tabela FIPE</b>, criada pela Fundação Instituto de Pesquisas Econômicas (FIPE), é
                    reconhecida por divulgar preços médios de mercado de carros, motos e caminhões, novos, seminovos
                    e usados, em todo o Brasil, para servir de parâmetro em negociações e avaliações dos automóveis.
                </p>
                <p data-testid="faq-content-01-p2" id="faq-content-01-p2">
                    No entanto, para transações, além das estimativas da tabela, leva-se em consideração outros
                    fatores como conservação, opcionais, revisões concluídas, entre outras especificidades que podem
                    influenciar uma oferta.
                </p>
            </div>
        ),
    },
    {
        question: 'Quando surgiu a FIPE?',
        answer: 'O órgão surgiu em 1973, à época, criado para auxiliar alguns cursos da Universidade de São Paulo (USP). Entre os vários serviços prestados, o mais conhecido deles, sem dúvida, é o Preço Médio de Veículos, também conhecido como Tabela FIPE.',
        questionJSX: <h3 data-testid="faq-question-02" id="faq-question-02">Quando surgiu a FIPE?</h3>,
        answerJSX: (
            <div data-testid="faq-content-02" id="faq-content-02">
                <p data-testid="faq-content-02-p1" id="faq-content-02-p1">
                    O órgão surgiu em 1973, à época, criado para auxiliar alguns cursos da Universidade de São Paulo
                    (USP). Entre os vários serviços prestados, o mais conhecido deles, sem dúvida, é o Preço Médio
                    de Veículos, também conhecido como Tabela FIPE.
                </p>
            </div>
        ),
    },
    {
        question: 'Como a Tabela FIPE funciona?',
        answer: 'Os valores médios divulgados são atualizados mensalmente. Para quem interesse em saber como é calculado a Tabela FIPE, vamos explicar. O índice é baseado na coleta de preços de automóveis em todo o território nacional. Para chegar na média, é realizado um filtro que exclui os preços muito discrepantes (para baixo ou para cima). Com os valores que restaram, aqueles que são próximos, é criado uma média de preço, divulgada todo mês na tabela. Para realizar uma pesquisa, os usuários podem filtrar por ano-modelo, motorização e versão do veículo de interesse.',
        questionJSX: <h3 data-testid="faq-question-03" id="faq-question-03">Como a Tabela FIPE funciona?</h3>,
        answerJSX: (
            <div data-testid="faq-content-03" id="faq-content-03">
                <p data-testid="faq-content-03-p1" id="faq-content-03-p1">
                    Os valores médios divulgados são atualizados mensalmente. Para quem interesse em saber{' '}
                    <b>como é calculado a Tabela FIPE</b>, vamos explicar.
                </p>
                <p data-testid="faq-content-03-p2" id="faq-content-03-p2">
                    O índice é baseado na coleta de preços de automóveis em todo o território nacional. Para chegar
                    na média, é realizado um filtro que exclui os preços muito discrepantes (para baixo ou para
                    cima).
                </p>
                <p data-testid="faq-content-03-p3" id="faq-content-03-p3">
                    Com os valores que restaram, aqueles que são próximos, é criado uma média de preço, divulgada
                    todo mês na tabela. Para realizar uma pesquisa, os usuários podem filtrar por ano-modelo,
                    motorização e versão do veículo de interesse.
                </p>
            </div>
        ),
    },
    {
        question: 'Quando usar a Tabela FIPE?',
        answer: 'Além de te oferecer a possibilidade de consultar os preços dos mais diversos veículos para comprar um modelo, a Tabela FIPE é ideal para quem está pensando em vender o seu próprio carro ou moto. Consultando a tabela você consegue traçar um ponto de partida para a avaliação do seu automóvel no mercado. Mas é importante lembrar: a FIPE é uma referência e, ao definir um valor, é importante levar como base outros fatores como a quilometragem, os itens de série, a quantidade de revisões realizadas, entre outras especificidades. Mas suas utilidades não se limitam apenas aos compradores ou vendedores de veículos. Os valores divulgados na Tabela FIPE são usados de parâmetro para o cálculo dos valores do IPVA e à indenização do seguro dos automóveis. Ou seja, ela também presta serviços ao governo e instituições privadas.',
        questionJSX: <h3 data-testid="faq-question-04" id="faq-question-04">Quando usar a Tabela FIPE?</h3>,
        answerJSX: (
            <div data-testid="faq-content-04" id="faq-content-04">
                <p data-testid="faq-content-04-p1" id="faq-content-04-p1">
                    Além de te oferecer a possibilidade de consultar os preços dos mais diversos veículos para
                    comprar um modelo, a Tabela FIPE é ideal para quem está pensando em vender o seu próprio carro
                    ou moto.
                </p>
                <p data-testid="faq-content-04-p2" id="faq-content-04-p2">
                    Consultando a tabela você consegue traçar um ponto de partida para a avaliação do seu automóvel
                    no mercado. Mas é importante lembrar: a FIPE é uma referência e, ao definir um valor, é
                    importante levar como base outros fatores como a quilometragem, os itens de série, a quantidade
                    de revisões realizadas, entre outras especificidades.
                </p>
                <p data-testid="faq-content-04-p3" id="faq-content-04-p3">
                    Mas suas utilidades não se limitam apenas aos compradores ou vendedores de veículos. Os valores
                    divulgados na Tabela FIPE são usados de parâmetro para o cálculo dos valores do IPVA e à
                    indenização do seguro dos automóveis. Ou seja, ela também presta serviços ao governo e
                    instituições privadas.
                </p>
            </div>
        ),
    },
    {
        question: 'O que é a Tabela Webmotors?',
        answer: 'Na Webmotors a tabela FIPE é comparada com as informações da própria plataforma, isso é, uma comparação do valor de tabela com os preços praticados no mercado real, levando em conta as transações feitas na própria plataforma da Webmotors, chamamos de Tabela Webmotors. Com isso, a principal vantagem é que você pode ter uma análise mais precisa e real de valores praticados pelo mercado.',
        questionJSX: <h3 data-testid="faq-question-05" id="faq-question-05">O que é a Tabela Webmotors?</h3>,
        answerJSX: (
            <div data-testid="faq-content-05" id="faq-content-05">
                <p data-testid="faq-content-05-p1" id="faq-content-05-p1">
                    Na Webmotors a tabela FIPE é comparada com as informações da própria plataforma, isso é, uma
                    comparação do valor de tabela com os preços praticados no mercado real, levando em conta as
                    transações feitas na própria plataforma da Webmotors, chamamos de Tabela Webmotors. Com isso, a
                    principal vantagem é que você pode ter uma análise mais precisa e real de valores praticados
                    pelo mercado.
                </p>
            </div>
        ),
    },
    {
        question: 'Como consultar a Tabela FIPE?',
        answer: 'Para facilitar a sua busca, busque o carro ou moto de interesse na Tabela FIPE e Tabela Webmotors e faça todas as pesquisas necessárias. E lembre-se, para aqueles interessados em comprar ou vender, saber o valor médio real negociado do modelo de interesse, é ideal para se ter como referência e conseguir bons resultados de compra e venda.',
        questionJSX: <h3 data-testid="faq-question-06" id="faq-question-06">Como consultar a Tabela FIPE?</h3>,
        answerJSX: (
            <div data-testid="faq-content-06" id="faq-content-06">
                <p data-testid="faq-content-06-p1" id="faq-content-06-p1">
                    Para facilitar a sua busca, busque o carro ou moto de interesse na{' '}
                    <b>Tabela FIPE e Tabela Webmotors</b> e faça todas as pesquisas necessárias. E lembre-se, para
                    aqueles interessados em comprar ou vender, saber o valor médio real negociado do modelo de
                    interesse, é ideal para se ter como referência e conseguir bons resultados de compra e venda.
                </p>
            </div>
        ),
    },
];
